import React, {Component, Fragment} from 'react';
import axios from 'axios';
import SDSForm from './SDSForm';
import AvailableSDS from './AvailableSDS';
import ChemwatchLinks from './ChemwatchLinks'
import Loader from './Loader';
import { getRecaptchaToken } from '../../utils';

const apiUrl = '/api/sds/';

// Defaults
const defaults = {
    countryId: '284', // Norway
    languageId: '340700' // English
};


export default class SDSRoot extends Component {
    constructor(props) {
        super(props);

        this.productId = this.props.productId;

        this.state = {
            isLoading: false,
            countryId: defaults.countryId,
            languageId: defaults.languageId,
            countriesList: [],
            languagesList: [],
            documentsList: [],
            shouldResultsRender: false,
            errorCountries: false,
            errorLanguages: false,
            errorDocuments: false,
            errorDownloadingPDF: false
        };

        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.handleFindSds = this.handleFindSds.bind(this);
        this.fetchPDF = this.fetchPDF.bind(this);
        this.fetchAllPDF = this.fetchAllPDF.bind(this);
    }

    componentDidMount() {
        this.fetchCountries();
        this.fetchLanguages();
    }

    fetchCountries() {
        this.setState({isLoading: true});

        const productId = this.productId;
        const url = `${apiUrl}GetCountries`;
        const params = {
            productId: productId
        };

        axios.get(url, {params: params})
            .then(result => {
                this.setState({
                    countriesList: result.data,
                    errorCountries: false,
                    isLoading: false
                });
            })
            .catch((error) => {
                this.handleFetchError(error);
                this.setState({
                    errorCountries: true,
                    countriesList: [],
                    isLoading: false
                });
            });
    }

    fetchLanguages() {
        this.setState({isLoading: true});

        const {countryId} = this.state;
        const productId = this.productId;
        const url = `${apiUrl}GetLanguages`;
        const params = {
            productId: productId,
            countryId: countryId
        };

        axios.get(url, {params: params})
            .then(result => {
                this.setState({
                    languagesList: result.data,
                    errorLanguages: false,
                    isLoading: false
                });
            })
            .catch((error) => {
                this.handleFetchError(error);
                this.setState({
                    errorLanguages: true,
                    languagesList: [],
                    isLoading: false
                });
            });
    }

    fetchDocuments() {
        this.setState({isLoading: true});

        const {countryId, languageId, languagesList} = this.state;
        const productId = this.productId;
        const url = `${apiUrl}GetDocuments`;
        const currentLanguageCode = languagesList.find(el => `${el.Id}` === `${languageId}`);
       
        getRecaptchaToken().then(token => {
            const params = {
                productId: productId,
                countryId: countryId,
                languageId: languageId,
                languageCode: currentLanguageCode.Code,
                token: token
            };

            axios.get(url, {params: params})
                .then(result => {
                    const documents = result.data,
                        areDocumentsAvailable = documents.MainDocument !== null || documents.RelatedDocuments.length > 0;
                       
                    this.setState({
                        errorDocuments: !areDocumentsAvailable,
                        documentsList: documents,
                        isLoading: false
                    }, () => this.setState({shouldResultsRender: true})
                    );
                })
                .catch((error) => {
                    this.handleFetchError(error);
                    this.setState({
                        errorDocuments: true,
                        documentsList: [],
                        isLoading: false
                    })
                });
        });
    }
   
    fetchAllPDF(event,documents){
        event.preventDefault();
        this.setState({isLoading: true});
        const getPdf = documents.map(doc=>{
            return axios.get(doc.Link, {method: 'GET', responseType: 'blob'})
                .then(result => {
                    const
                        blob = new Blob([result.data], {type: 'application/pdf'}),
                        fileNamePDFExtension = `${doc.FileName}.pdf`;
   
                    if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        window.navigator.msSaveBlob(blob, fileNamePDFExtension);
                        return;
                    }
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileNamePDFExtension);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                   
                })
                .catch((error) => {
                    this.setState({
                        errorDownloadingPDF: true,
                        isLoading: false,
                    });
                    console.log(error);
                });
            }
        );
        Promise.all(getPdf).then(()=>{
            this.setState({
                isLoading: false,
                errorDownloadingPDF: false
                }
            );
        })
    }

    fetchPDF(event, url, fileName) {
        event.preventDefault();
        this.setState({isLoading: true});

        axios.get(url, {method: 'GET', responseType: 'blob'})
            .then(result => {
                this.setState({
                    isLoading: false,
                    errorDownloadingPDF: false
                });

                const
                    blob = new Blob([result.data], {type: 'application/pdf'}),
                    fileNamePDFExtension = `${fileName}.pdf`;

                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    window.navigator.msSaveBlob(blob, fileNamePDFExtension);
                    return;
                }

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileNamePDFExtension);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((error) => {
                this.setState({
                    errorDownloadingPDF: true,
                    isLoading: false,
                });
                console.log(error);
            });
    }

    handleFetchError(error) {
        if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log('Error', error.message);
        }
        console.log(error.config);
    }

    handleCountryChange(countryId) {
        this.setState({
            countryId: countryId.toString(),
            shouldResultsRender: false,
            languageId: defaults.languageId,
            errorDownloadingPDF: false
        }, this.fetchLanguages);
    }

    handleLanguageChange(languageId) {
        this.setState({
            languageId: languageId.toString(),
            shouldResultsRender: false,
            errorDownloadingPDF: false
        });
    }

    handleFindSds(e) {
        e.preventDefault();
        this.fetchDocuments();
    }

    render() {
        const {
            countryId,
            languageId,
            languagesList,
            countriesList,
            documentsList,
            shouldResultsRender,
            errorCountries,
            errorLanguages,
            errorDocuments,
            errorDownloadingPDF,
            isLoading
        } = this.state;


        return (
            <Fragment>
                {isLoading && <Loader small={true}/>}
                <SDSForm
                    isLoading={isLoading}
                    selectedCountryId={countryId}
                    selectedLanguageId={languageId}
                    languagesList={languagesList}
                    countriesList={countriesList}
                    errorCountries={errorCountries}
                    errorLanguages={errorLanguages}
                    handleCountryChange={this.handleCountryChange}
                    handleLanguageChange={this.handleLanguageChange}
                    handleFindSds={this.handleFindSds}
                />
                <AvailableSDS
                    shouldResultsRender={shouldResultsRender}
                    documentsList={documentsList}
                    errorDocuments={errorDocuments}
                    errorDownloadingPDF={errorDownloadingPDF}
                    fetchPDF={this.fetchPDF}
                    fetchAllPDF={this.fetchAllPDF}
                />
                <ChemwatchLinks />
            </Fragment>
        )
    }
}